import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'help_center-self_serve_order_search-keyboard_input';

/**
 * Track first typing in self-serve order search event, to understand % of user using the search when visiting order page
 */
export function trackHelpCenterSelfServeOrderSearchKeyboardInput(
  retailerToken: string,
  brandToken: string,
  search_term: string,
  is_improved_navigation_flow2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: {
      retailerToken,
      brandToken,
      search_term,
      is_improved_navigation_flow2,
    },
  });
}
